import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { AgentHierarchyBranchHandler } from './agent-hierarchy-branch.handler';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-agent-hierarchy-branch',
  templateUrl: './agent-hierarchy-branch.component.html',
  styleUrls: ['./agent-hierarchy-branch.component.scss'],
})
export class AgentHierarchyBranchComponent extends AgentHierarchyBranchHandler {
  constructor(public service: AgentService, public router: Router, public settingService: SettingService) {
    super(service, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
